var _effectorFileName = "/builds/gmini/front-common/src/classifier-editor/ClassifierTree/buildTreeItemKey.ts";
import "core-js/modules/es.array.concat.js";
import { isGroupType } from "../../classifier-service/adapters";
export function buildTreeItemKey(_ref) {
  var id = _ref.id,
      type = _ref.type;
  return isGroupType(type) ? "UserClassifierGroupNode_".concat(id) : "".concat(type, "_").concat(id);
}